export default __webpack_public_path__ + "static/media/dimitard_s.2bdfcde2.jpg";